const filenameFromPath = (path) => {
  return path.split("/").reverse()[0];
};

export default filenameFromPath;
